var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
import { isErr } from "healthex-common/result";
import { NamedRoutes } from "./NamedRoutes";
import { AuthType } from "healthex-common/auth.dtos";
import { LoginPage } from "./LoginUIManager";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("common");
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export class LoginViewModel {
    constructor(container) {
        this.input = { email: "", password: "" };
        this.authTypeResponse = null;
        this.error = null;
        this.environment = container.environment;
        this.authManager = container.authManager;
        this.routingUIManager = container.routingUIManager;
        this.loginUIManager = container.loginUIManager;
    }
    get organization() {
        return this.loginUIManager.organization;
    }
    get isLoggedIn() {
        return this.authManager.isLoggedIn;
    }
    updateInput(update) {
        this.input = {
            ...this.input,
            ...Object.entries(update).reduce((acc, [key, value]) => {
                acc[key] = key === "email" ? value.trim() : value;
                return acc;
            }, {}),
        };
    }
    resetAuthResponse() {
        this.authTypeResponse = null;
    }
    get isAuthTypePassword() {
        return this.authTypeResponse && this.authTypeResponse.authType === AuthType.USERNAME_PASSWORD;
    }
    get isFormValid() {
        return this.isEmailValid && this.input.password !== "";
    }
    get isEmailValid() {
        return EMAIL_REGEX.test(this.input.email);
    }
    async fetchAuthType() {
        this.authTypeResponse = await this.authManager.getAuthTypeByEmail(this.input.email);
        if (this.authTypeResponse.authType === AuthType.SSO_SAML) {
            const redirectURL = this.authTypeResponse.redirectUrl;
            if (redirectURL) {
                window.location.href = redirectURL;
            }
        }
    }
    forgotPassword() {
        this.routingUIManager.navigateTo(NamedRoutes.FORGOT_PASSWORD);
    }
    async login() {
        const result = await this.authManager.authenticateByPassword(this.input.email, this.input.password);
        if (isErr(result)) {
            switch (result.error) {
                case "INCORRECT_CREDENTIALS":
                    this.error = t("Incorrect email or password! Please try again.");
                    break;
                case "ACCOUNT_LOCKED":
                    this.error = t("Your account is temporarily locked to prevent unauthorized use. You can either reset your password or try again later. If you still have trouble, contact your administrator.");
                    break;
                case "EXPIRED_PASSWORD":
                    this.error = t("Your password has expired and must be changed to proceed.");
                    this.routingUIManager.navigateTo(NamedRoutes.EXPIRED_PASSWORD, { userEmailAddress: this.input.email });
                    break;
                case "ADMIN_PASSWORD_RESET":
                    this.error = t("Your adminstrator has forced you to change your password. Instructions have been sent to your email. If you still have trouble, contact your administrator.");
                    break;
                default:
                    this.error = t("An unexpected error occurred");
            }
        }
        else {
            this.error = null;
        }
    }
    loginAsPatient() {
        this.loginUIManager.setLoginPage(LoginPage.PATIENT_LOGIN, undefined);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViewModel.prototype, "input", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViewModel.prototype, "authTypeResponse", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViewModel.prototype, "error", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LoginViewModel.prototype, "organization", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LoginViewModel.prototype, "isLoggedIn", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LoginViewModel.prototype, "isAuthTypePassword", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LoginViewModel.prototype, "isFormValid", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LoginViewModel.prototype, "isEmailValid", null);
